import "./styles.modules.scss";

import React, { useState, useEffect, Fragment } from "react";
import { Button, Form } from "react-bootstrap";

import { BsTrash as TrashIco } from "react-icons/bs";

const AlternativeCard = ({ item, index, trashEvent }) => {
  const [cont, setCont] = useState(item?.description?.length || 0);

  return (
    <div className="altIt">
      <div className="altItSelec altItSelecItemCustom">
        <Form.Control
          as="textarea"
          rows={1}
          defaultValue={item.description}
          maxlength="45"
          onChange={(e) => {
            item.description = e.currentTarget.value;
            setCont(e.currentTarget.value.length);
          }}
          placeholder={`Alternativa ${index + 1}`}
        />
        <div className="contador">
          <span>{cont}</span>/45
        </div>
      </div>

      <div className="altRemove">
        <p>Remover</p>
        <button
          onClick={() => {
            trashEvent(index);
          }}
        >
          <TrashIco />
        </button>
      </div>
    </div>
  );
};

const SingleOptionComment = ({ questionOptions, setQuestionOptions }) => {
  const addAlt = () => {
    setQuestionOptions((item) => [...item, { description: "", isCorrect: true }]);
  };

  const trashEvent = (index) => {
    const trashQuestion = [...questionOptions];
    trashQuestion.splice(index, 1);
    setQuestionOptions(trashQuestion);
  };

  return (
    <div className="form-group form-group-block-02">
      <div className="card">
        <div className="card-header template-card-header">Alternativas + texto livre</div>
        <div className="card-body template-card-body">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 altContainer">
              {/* <p>Adicione as alternativas e marque a resposta correta</p> */}

              <div className="altList">
                {questionOptions.length > 0 ? (
                  questionOptions.map((item, index) => {
                    return (
                      <Fragment key={index}>
                        <AlternativeCard item={item} index={index} />
                      </Fragment>
                    );
                  })
                ) : (
                  <div className="noAlternative">Sem nenhuma alternativa.</div>
                )}
              </div>

              <Button
                variant="warning"
                className="btnAdd"
                onClick={() => {
                  addAlt();
                }}
              >
                Adicionar nova alternativa
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleOptionComment;
